import { render, staticRenderFns } from "./rollingCastle.vue?vue&type=template&id=7654e65d&scoped=true&"
import script from "./rollingCastle.vue?vue&type=script&lang=js&"
export * from "./rollingCastle.vue?vue&type=script&lang=js&"
import style0 from "./rollingCastle.vue?vue&type=style&index=0&id=7654e65d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7654e65d",
  null
  
)

export default component.exports